module.exports = __webpack_public_path__ + "static/media/logo.e02c2107.png";